import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import Icon from '../../../components/AppIcon';

const RiskSegmentationChart = ({ data }) => {
  const COLORS = {
    'Low Risk': 'var(--color-success)',
    'Medium Risk': 'var(--color-warning)',
    'High Risk': 'var(--color-error)',
    'Critical': 'var(--color-destructive)'
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-popover border border-border rounded-lg p-3 shadow-elevation-3">
          <p className="text-sm font-semibold text-foreground mb-1">{payload?.[0]?.name}</p>
          <p className="text-xs text-muted-foreground">
            {payload?.[0]?.value} employees ({payload?.[0]?.payload?.percentage}%)
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-6 lg:p-8 shadow-elevation-2 border border-border">
      <div className="flex items-start justify-between mb-4 md:mb-6">
        <div>
          <h3 className="text-base md:text-lg lg:text-xl font-semibold text-foreground mb-1 md:mb-2">
            Risk Segmentation
          </h3>
          <p className="text-xs md:text-sm text-muted-foreground">
            Employee distribution by financial risk level
          </p>
        </div>
        <div className="p-2 md:p-3 rounded-lg bg-primary/10">
          <Icon name="PieChart" size={20} className="text-primary" />
        </div>
      </div>
      <div className="w-full h-64 md:h-72 lg:h-80" aria-label="Risk Segmentation Pie Chart">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              labelLine={false}
              outerRadius="80%"
              fill="#8884d8"
              dataKey="value"
              label={({ name, percentage }) => `${name}: ${percentage}%`}
            >
              {data?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS?.[entry?.name]} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              verticalAlign="bottom" 
              height={36}
              iconType="circle"
              wrapperStyle={{ fontSize: '12px' }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 mt-4 md:mt-6 pt-4 md:pt-6 border-t border-border">
        {data?.map((item) => (
          <div key={item?.name} className="text-center">
            <div 
              className="w-3 h-3 md:w-4 md:h-4 rounded-full mx-auto mb-2" 
              style={{ backgroundColor: COLORS?.[item?.name] }}
            />
            <p className="text-xs md:text-sm font-medium text-foreground">{item?.value}</p>
            <p className="text-xs text-muted-foreground">{item?.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RiskSegmentationChart;